var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-block header"},[_c('h1',[_vm._v(_vm._s(_vm.$tr('analytics.title')))]),_vm._v(" "),_c('Selectors',{staticClass:"selectors"}),_vm._v(" "),_c('DatePicker',{staticClass:"align-end",attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }